"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StitchReadOperationBrowser_1 = __importDefault(require("./StitchReadOperationBrowser"));

var StitchCollectionBrowser =
/** @class */
function () {
  function StitchCollectionBrowser(coll) {
    this.coll = coll;
    this.namespace = coll.namespace;
  }

  StitchCollectionBrowser.prototype.count = function (query, options) {
    return this.coll.count(query, options);
  };

  StitchCollectionBrowser.prototype.find = function (query, options) {
    return new StitchReadOperationBrowser_1.default(this.coll.find(query, options));
  };

  StitchCollectionBrowser.prototype.findOne = function (query, options) {
    return this.coll.findOne(query, options);
  };

  StitchCollectionBrowser.prototype.findOneAndUpdate = function (query, update, options) {
    return this.coll.findOneAndUpdate(query, update, options);
  };

  StitchCollectionBrowser.prototype.findOneAndDelete = function (query, options) {
    return this.coll.findOneAndDelete(query, options);
  };

  StitchCollectionBrowser.prototype.updateOne = function (query, update, updateOptions) {
    return this.coll.updateOne(query, update, updateOptions);
  };

  StitchCollectionBrowser.prototype.updateMany = function (query, update, updateOptions) {
    return this.coll.updateMany(query, update, updateOptions);
  };

  StitchCollectionBrowser.prototype.insertOne = function (doc) {
    return this.coll.insertOne(doc);
  };

  StitchCollectionBrowser.prototype.watch = function (arg) {
    return this.coll.watch(arg);
  };

  StitchCollectionBrowser.prototype.aggregate = function (pipeline) {
    var prom = this.coll.aggregate(pipeline).asArray();
    return prom;
  };

  StitchCollectionBrowser.prototype.delete = function (query) {
    return this.coll.deleteOne(query);
  };

  return StitchCollectionBrowser;
}();

exports.default = StitchCollectionBrowser;